import React from 'react';

const Loader = () => {
  return (
    <></>
  )
}

Loader.Table = () => {
  return (
    <div className="p-4 w-full h-full">
    <div className="animate-pulse flex space-x-4">
      <div className="flex-1 space-y-4 py-1">
        <div className="h-4 bg-gray-400 rounded w-3/4"></div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-400 rounded"></div>
          <div className="h-4 bg-gray-400 rounded w-5/6"></div>
          <div className="h-4 bg-gray-400 rounded w-5/6"></div>
          <div className="h-4 bg-gray-400 rounded w-4/6"></div>
          <br/>
          <br/>
          <br/>
          <div className="h-4 bg-gray-400 rounded"></div>
          <div className="h-4 bg-gray-400 rounded w-32"></div>
          <div className="h-4 bg-gray-400 rounded w-64"></div>
        </div>
      </div>
    </div>
  </div>
  )
}

Loader.Avatar = () => {
  return (
    <div className="avatar animate-pulse bg-gray-400" />
  )
}

Loader.User = () => {
  return (
    <div className="p-4 w-full h-full">
      <div className="animate-pulse flex space-x-2 items-center">
        <div className="h-4 w-4 bg-gray-400 rounded-full"/>
        <div className="h-4 flex-1 bg-gray-400 rounded"/>
      </div>
    </div>
  )
}

Loader.UserEmail = () => {
  return (
    <div className="flex flex-col space-y-2 p-4 w-full h-full">
      <div className="animate-pulse flex space-x-2 items-center">
        <div className="h-4 w-4 bg-gray-400 rounded-full"/>
        <div className="h-4 w-2/4  bg-gray-400 rounded"/>
      </div>
      <div className="flex space-x-2 items-center">
        <div className="h-2 w-1/4 bg-gray-400 rounded"/>
      </div>
    </div>
  )
}



export default Loader